import { ViewerContext, localStorage } from "dash-ui";
import { useLogoutMutation } from "gql/generated.graphql";
import { useContext } from "react";
import * as Sentry from "@sentry/react";
import { client } from "gql/client";
import { resetIdentity } from "shared/analytics";
import { portalLanguagePick } from "shared/i18n";

export const useLogout = (): [() => void, boolean] => {
  const [logoutMutation, { loading }] = useLogoutMutation();
  const {
    setAccount,
    setTokens,
    setProfile,
    setBroker,
    setSubscription,
    setUserHasTrialed,
  } = useContext(ViewerContext);

  return [
    () => {
      // Clear user data immediately for instant UI feedback
      if (
        setAccount &&
        setTokens &&
        setProfile &&
        setBroker &&
        setSubscription &&
        setUserHasTrialed
      ) {
        setProfile({});
        setBroker({});
        setAccount(null);
        setSubscription(null);
        setUserHasTrialed(null);
        Sentry.getCurrentScope().clear();
        resetIdentity();
      }
      // The pick is temporary: the next person on this browser starts from their own account.
      portalLanguagePick.clear();

      // Fire the mutation (don't await - let it run in background)
      logoutMutation({
        onCompleted: () => {
          client.clearStore();

          // Clear tokens and storage after successful logout
          localStorage.setAccessToken("");
          localStorage.setRefreshToken("");
          localStorage.setRefreshTokenExpiry("");
          localStorage.setApiReferralCode("");
          localStorage.setApiFirstAccess("");

          // Clear tokens from context
          if (setTokens) {
            setTokens({});
          }
        },
        onError: (error) => {
          console.error("Logout mutation error:", error);

          // Clear tokens even on error to complete the logout
          localStorage.setAccessToken("");
          localStorage.setRefreshToken("");
          localStorage.setRefreshTokenExpiry("");
          localStorage.setApiReferralCode("");
          localStorage.setApiFirstAccess("");

          if (setTokens) {
            setTokens({});
          }
        },
      });
    },
    loading,
  ];
};
